module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "demo-login",
      "transition": "pop-out",
      "width": _vm.modalWidth,
      "height": 400
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-part",
    attrs: {
      "id": "bp-left"
    }
  }, [_c('div', {
    staticClass: "partition",
    attrs: {
      "id": "partition-register"
    }
  }, [_c('div', {
    staticClass: "partition-title"
  }, [_vm._v("CREATE ACCOUNT")]), _vm._v(" "), _c('div', {
    staticClass: "partition-form"
  }, [_c('form', {
    attrs: {
      "autocomplete": "false"
    }
  }, [_c('div', {
    staticClass: "autocomplete-fix"
  }, [_c('input', {
    attrs: {
      "type": "password"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "n-email",
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "n-username",
      "type": "text",
      "placeholder": "Username"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "n-password2",
      "type": "password",
      "placeholder": "Password"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "42px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('button', {
    attrs: {
      "id": "goto-signin-btn"
    }
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "register-btn"
    }
  }, [_vm._v("Register")])]), _vm._v(" "), _c('button', {
    staticClass: "large-btn github-btn"
  }, [_vm._v("connect with "), _c('span', [_vm._v("github")])]), _vm._v(" "), _c('button', {
    staticClass: "large-btn facebook-btn"
  }, [_vm._v("connect with "), _c('span', [_vm._v("facebook")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-part",
    attrs: {
      "id": "bp-right"
    }
  }, [_c('div', {
    staticClass: "box-messages"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a32d827"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DemoLoginModal.vue
// module id = 35
// module chunks = 0